var map = {
	"./": [
		"6ebf"
	],
	"./cn": [
		"f66c"
	],
	"./cn.ts": [
		"f66c"
	],
	"./en": [
		"84ff",
		"lang-en"
	],
	"./en.old": [
		"950b",
		"lang-en-old"
	],
	"./en.old.ts": [
		"950b",
		"lang-en-old"
	],
	"./en.ts": [
		"84ff",
		"lang-en"
	],
	"./index": [
		"6ebf"
	],
	"./index.ts": [
		"6ebf"
	],
	"./jp": [
		"48de",
		"lang-jp"
	],
	"./jp.ts": [
		"48de",
		"lang-jp"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;